type PrototypeSurfaceListener = () => void;

const prototypeSurfaceListeners = new Set<PrototypeSurfaceListener>();
let activePrototypeSurfaceCount = 0;

const notifyPrototypeSurfaceListeners = () => {
  prototypeSurfaceListeners.forEach((listener) => listener());
};

export function registerPrototypeSurface() {
  activePrototypeSurfaceCount += 1;
  notifyPrototypeSurfaceListeners();

  let registered = true;

  return () => {
    if (!registered) {
      return;
    }

    registered = false;
    activePrototypeSurfaceCount = Math.max(0, activePrototypeSurfaceCount - 1);
    notifyPrototypeSurfaceListeners();
  };
}

export function getActivePrototypeSurfaceCount() {
  return activePrototypeSurfaceCount;
}

export function subscribePrototypeSurfaces(listener: PrototypeSurfaceListener) {
  prototypeSurfaceListeners.add(listener);

  return () => {
    prototypeSurfaceListeners.delete(listener);
  };
}
